import * as analyse from '../services/index';
export default {
  namespace: 'analyse',
  state: {
    registerShopSort: [],
    buyShopSort: [],
    performSort: [],
    shoeSort: [],
    packetSort: [],
    memberSpread: [],
    cancellateUseRate: [],
    activityDetail: [],
    cancellateRate: [],
    registerDay: [],
    visitedDay: [],
    deadLineTime: {},
    newMemberRegister: [],
    visitedMemberSall: [],
  },
  effects: {
    *registerShopSort({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.registerShopSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          registerShopSort: response?.data,
        },
      });
    },
    *buyShopSort({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.buyShopSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          buyShopSort: response?.data,
        },
      });
    },
    *performSort({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.performSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          performSort: response?.data,
        },
      });
    },
    *shoeSort({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.shoeSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          shoeSort: response?.data,
        },
      });
    },
    *packetSort({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.packetSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          packetSort: response?.data,
        },
      });
    },
    *memberSpread({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.memberSpread, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          memberSpread: response?.data,
        },
      });
    },
    *cancellateUseRate({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.cancellateUseRate, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          cancellateUseRate: response?.data,
        },
      });
    },
    *activityDetail({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.activityDetail, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          activityDetail: response?.data,
        },
      });
    },
    *cancellateRate({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.cancellateRate, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          cancellateRate: response?.data,
        },
      });
    },
    *registerDay({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.registerDay, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          registerDay: response?.data,
        },
      });
    },
    *visitedDay({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.visitedDay, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          visitedDay: response?.data,
        },
      });
    },
    *deadLineTime({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.deadLineTime, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          deadLineTime: response?.data,
        },
      });
    },
    *newMemberRegister({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.newMemberRegister, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          newMemberRegister: response?.data,
        },
      });
    },
    *visitedMemberSall({ payload: { values } }, { call, put }) {
      const response = yield call(analyse.visitedMemberSall, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          visitedMemberSall: response?.data,
        },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
